module.exports = __webpack_public_path__ + "img/chair-cgi2.d51c5837.jpg";